<template>
  <v-app data-doctors-register-app>
    <DoctorsRegisterContent />
    <component
      :is="BaseDialog"
      v-if="BaseDialog"
    />
  </v-app>
</template>

<script lang="ts" setup>
import DoctorsRegisterContent from 'src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/DoctorsRegisterContent.vue'
import { onMounted, shallowRef } from 'vue'

const BaseDialog = shallowRef<any>()

onMounted(async () => {
  if (typeof document !== 'undefined') {
    // TODO: заменить на версию для серверного рендера
    BaseDialog.value = (await import(/* webpackMode: 'eager' */'www/vue_components/common/core/BaseDialog/BaseDialog.vue')).default
  }
})
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/mixins';

#data-doctors-register-app {
  @include v-app-reset;
}
</style>
